
import { Token } from "./token";

export class TokenGroup {

    constructor(public Tokens: Token[], public Error = "") {

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/search-tree/token-group.ts